import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=518cb5a9&scoped=true"
import script from "./ClientsList.vue?vue&type=script&lang=ts"
export * from "./ClientsList.vue?vue&type=script&lang=ts"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=518cb5a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518cb5a9",
  null
  
)

export default component.exports